import { notificationsApi } from '@/shared/services/apis/notifications-api.service';
import type {
  NotificationRecord,
  NotificationSearchPayload
} from '@/shared/types/notification.types';

export async function searchNotifications(
  payload: NotificationSearchPayload
): Promise<{ items: NotificationRecord[]; total: number }> {
  const response = await notificationsApi.search(payload);
  if (!response.ok || !Array.isArray(response.data?.data)) {
    return { items: [], total: 0 };
  }
  const items = response.data.data;
  const total = response.data.total ?? items.length;
  return { items, total };
}

export async function fetchUnreadCount(filter: { platform?: string } = {}): Promise<number> {
  const response = await notificationsApi.unreadCount(filter);
  if (!response.ok || !response.data) return 0;
  return response.data.count ?? 0;
}

export async function markNotificationRead(id: string): Promise<boolean> {
  const response = await notificationsApi.markRead(id);
  return response.ok === true;
}

export async function markAllNotificationsRead(): Promise<boolean> {
  const response = await notificationsApi.markAllRead();
  return response.ok === true;
}
